// JS for block-specific behavior only
console.log('res copy bg block loaded');